export const MultipleTestPageObject = (
    onAddInstance: () => void,
    instancesLength: number,
    handleRemoveInstance: (instance: string) => void
) => ({
    getType: () => "Multiple",

    addInstance: () => onAddInstance(),

    deleteInstance: (instance: string) => handleRemoveInstance(instance),

    getInstancesCount: () => instancesLength,
});
